import React, { useEffect } from "react";
import "./castingDirector.css";
import DirectorImage from "../../assets/director.webp";
import { useNavigate } from "react-router-dom";
import { getContent } from "../../api/adminApi/content";

const Top = () => {
  const navigate = useNavigate();

  const [content, setContent] = React.useState({
      "title1": "",
      "title2": "",
      "title3": "",
      "title4": "",
      "title5": "",
      "title6": "",
      "content1": "",
      "content2": "",
      "content3": "",
      "content4": "",
      "content5": "",
      "content6": ""
    });
  
    useEffect(() => {
      getContent().then((res) => {
        // console.log(res.data.title2);
        setContent(res.data);
      });
    }, []);

  const handleRegisterClick = () => {
    navigate("/register");
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div className="director-top-full-wrapper">
      <div className="director-top-conainer">
        <div className="directorTop-smallImage">
          <img
            className="director-top-small-image"
            src={DirectorImage}
            alt=""
          />
        </div>
        <div className="directorTop-left">
          <span className="main-title">
            {content.title3}
            {/* Discover the Future Stars – Crafting Legacies of Talent! */}
          </span>
          <span className="director-subColor-title">
            {content.title4}
            {/* Unleash the potential of the next generation of stars with our
            comprehensive casting platform tailored specifically for children.
            Whether you're in need of a baby for a commercial, a tween for a TV
            show, or a teenager for a feature film, our platform connects you
            with exceptional young talent across the United States and Canada. */}
          </span>
          <div className="homeTop-buttons">
            <button className="homeMiddle2" onClick={handleRegisterClick}>
              Post Your Casting Call
            </button>
          </div>
        </div>
        <div className="directorTop-right">
          <img className="director-top-image" src={DirectorImage} alt="" />
        </div>
      </div>
    </div>
  );
};

export default Top;
